import BookmarkIcon from '@mui/icons-material/Bookmark';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import { SidebarInterface } from './types';
import strings from '../../resources/strings';
import routes from '../../resources/routes';
import UserRoles from '../../resources/enums/UserRoles';
import CalendarViewMonth from '@mui/icons-material/CalendarViewMonth';

const adminSettings: SidebarInterface[] = [
    {
        id: 1,
        title: strings.sidebar.adminSettings[0],
        img: BookmarkIcon,
        url: routes.USERS,
        roles: [UserRoles.SuperAdmin],
    },
    {
        id: 2,
        title: strings.sidebar.adminSettings[2],
        img: CategoryOutlinedIcon,
        url: routes.CHARGEABLE_PRODUCTS,
        roles: [UserRoles.SuperAdmin, UserRoles.Admin],
    },
    {
        id: 3,
        title: strings.sidebar.sidebarInfo[10],
        url: routes.CHAT_SCHEDULE,
        img: CalendarViewMonth,
        roles: [UserRoles.SuperAdmin],
    },
];

export default adminSettings;
